import { DeleteDependentDialogContainer } from '@/features/tax-profile/individual-profiles/components/DeleteDependentDialog/DeleteDependentDialogContainer'
import { DeleteTaxRefundMethodDialogContainer } from '@/features/tax-profile/tax-refund-methods/components/DeleteTaxRefundMethodDialog/DeleteTaxRefundMethodDialogContainer'
import { DeleteBusinessProfileDialogContainer } from '@/features/tax-profile/business-profiles/components/DeleteBusinessProfileDialog/DeleteBusinessProfileDialogContainer'
import { useFeatures } from '@/contexts/root-store-context'
import { observer } from 'mobx-react-lite'

/**
 * Inner component which requests the actual loading of the module.
 */
export default observer(function Inner() {
  const { internal } = useFeatures(({ taxProfile }) => ({
    internal: taxProfile.internal(),
  }))

  return (
    <>
      <DeleteDependentDialogContainer
        vm={internal.deleteDependentDialogViewModel}
      />
      <DeleteTaxRefundMethodDialogContainer
        vm={internal.deleteTaxRefundMethodDialogViewModel}
      />
      <DeleteBusinessProfileDialogContainer
        vm={internal.deleteBusinessProfileDialogViewModel}
      />
    </>
  )
})
